import { useState } from 'react';
import SubscribersHeader from 'components/subscribers/SubscribersHeader';
import SubscribersFilters from 'components/subscribers/SubscribersFilters';
import SubscribersTable from 'components/subscribers/SubscribersTable';

export default function Subscribers() {
  const [selectedTime, setSelectedTime] = useState('all');
  const [filters, setFilters] = useState({
    status: '',
    customer: '',
    subscriptionType: '',
    billingPeriod: '',
    paymentStatus: '',
    startDate: null,
    endDate: null,
    search: ''
  });

  return (
    <div className="h-full flex flex-col overflow-hidden overflow-y-auto relative">
      <div className="flex-none p-6 pb-0">
        <div className="mb-6">
          <SubscribersHeader 
            selectedTime={selectedTime} 
            setSelectedTime={setSelectedTime} 
          />
        </div>
      </div>
      
      {/* Sticky header and filters */}
      <div className="sticky top-0 z-10 bg-[#232323] px-6 pb-2 ">
        <div className="mb-6">
          <h1 className="text-xl font-semibold text-white">Subscribers Management</h1>
        </div>
        <SubscribersFilters 
          filters={filters}
          setFilters={setFilters}
        />
      </div>
      
      <div className="flex-1 px-6 pb-6 mt-4">
        <SubscribersTable filters={filters} />
      </div>
    </div>
  );
} 